import TabsV from './TabsV';

export default TabsV;
